module.exports = __webpack_public_path__ + "img/car_00034.edc96c32.jpg";